//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DialogPlugin } from 'tdesign-vue';
import { getTdesignFormValidateResult } from '@/utils/util';
const initForm = {
  name: '',
  code: '',
  description: '',
};
export default {
  name: 'PermissionSetEdit',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editRow: {
      type: Object,
      default: () => {
        return {};
      },
    },
    appid: {
      type: [Number, String],
      default: '',
    },
    isCopy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: initForm,
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入code',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    title() {
      if (this.isCopy) {
        return '复制权限包';
      }
      if (!this.editRow.code) {
        return '新建权限包';
      }
      return '编辑权限包';
    },
  },
  watch: {
    editRow(row) {
      this.form = {
        ...row,
      };
    },
  },
  methods: {
    onClose() {
      const confirmDia = DialogPlugin.confirm({
        header: '提示',
        body: '所作更改将不会被保存，确认关闭?',
        confirmBtn: '确定',
        theme: 'warning',
        cancelBtn: '取消',
        onConfirm: () => {
          confirmDia.hide();
          this.$emit('close');
        },
        onClose: () => {
          confirmDia.hide();
        },
      });
    },
    async onConfirm() {
      const valid = getTdesignFormValidateResult(await this.$refs.ruleForm.validate());

      if (!valid) return;
      console.log('meowf', this.form);
      let request;
      if (!this.editRow.id) {
        console.log('创建权限包');
        request = this.$request({
          url: this.$api.createRole,
          data: {
            ...this.form,
            code: `PermissionSet-${this.form.code}`,
            appid: this.appid,
            type: 'perm_set',
          },
        });
      } else if (this.isCopy) {
        console.log('复制权限包');
        request = this.$request({
          url: this.$api.copyRole,
          data: {
            ...this.form,
            code: `PermissionSet-${this.form.code}`,
            type: 'perm_set',
            copy_type: 0,
          },
        });
      } else {
        console.log('修改权限包');
        request = this.$request({
          url: this.$api.updateRole,
          data: {
            ...this.form,
            code: `PermissionSet-${this.form.code}`,
            type: 'perm_set',
          },
        });
      }
      request.then(() => {
        this.$message.success(this.editRow.id ? '编辑成功' : '新增成功');
        if (!this.editRow.id) {
          this.$message.success('新增成功');
        } else if (this.isCopy) {
          this.$message.success('复制成功');
        } else {
          this.$message.success('编辑成功');
        }
        this.$emit('refresh');
      });
    },
  },
};
